/* ----------------------------------------------------------------------------
   KOPSTORM CRO SCRIPTS
   ----------------------------------------------------------------------------
   Everything in this file cooperates with the split test flags defined in
   snippets/kopstorm-flags.liquid (window.KopstormTests, html[data-kopstorm-*]
   attributes, and the "kopstorm:flag" event fired when Intelligems flips a
   flag mid-page). Behavior with every flag off must be identical to the
   previous live theme.
---------------------------------------------------------------------------- */

(function () {
  'use strict';

  var html = document.documentElement;

  function croActive() {
    return html.hasAttribute('data-kopstorm-cro');
  }

  /* --------------------------------------------------------------------------
     Size chart dedupe (CRO variant only): when the theme variant picker renders
     its own size chart button, hide any additional app-injected element whose
     visible text is only "Size Chart" so the link does not appear twice.
  -------------------------------------------------------------------------- */

  function dedupeSizeChart() {
    if (!croActive()) return;

    var themeSizeChart = document.querySelector('.product-info [aria-controls^="size-chart-"]');
    if (!themeSizeChart) return;

    var candidates = document.querySelectorAll('.product-info a, .product-info button, .product-info span');

    candidates.forEach(function (el) {
      if (el === themeSizeChart) return;
      if (el.closest('[aria-controls^="size-chart-"]')) return;
      if (el.querySelector('a, button')) return;

      var text = (el.textContent || '').trim().toLowerCase();

      if (text === 'size chart' || text === 'size guide') {
        var target = el.closest('div[class*="size"], div[id*="size"]') || el;
        target.style.display = 'none';
      }
    });
  }

  /* --------------------------------------------------------------------------
     Announcement bar: CRO-only messages render with [hidden] and
     data-kopstorm-cro-cell. The theme carousel's cells getter live-filters
     [hidden] children, so toggling the attribute at any time is enough for
     the rotation to include or skip them.
  -------------------------------------------------------------------------- */

  function syncAnnouncementMessages() {
    var on = croActive();

    document.querySelectorAll('[data-kopstorm-cro-cell]').forEach(function (cell) {
      cell.hidden = !on;
    });
  }

  /* --------------------------------------------------------------------------
     Evergreen (rolling, per-visitor) countdown: ticks every element carrying
     data-kopstorm-evergreen. The target timestamp persists in localStorage
     under data-key so the window survives navigation and reloads.
  -------------------------------------------------------------------------- */

  function initEvergreenTimers() {
    document.querySelectorAll('[data-kopstorm-evergreen]:not([data-kopstorm-evergreen-ready])').forEach(function (el) {
      el.setAttribute('data-kopstorm-evergreen-ready', '');

      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var key = el.getAttribute('data-key');
      var duration = hours * 3600 * 1000;

      var units = {
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]')
      };

      function readTarget() {
        var now = Date.now();
        var stored;
        try {
          stored = parseInt(window.localStorage.getItem(key), 10);
        } catch (e) {
          stored = NaN;
        }
        if (!stored || isNaN(stored) || stored <= now) {
          stored = now + duration;
          try {
            window.localStorage.setItem(key, String(stored));
          } catch (e) {}
        }
        return stored;
      }

      var target = readTarget();

      function pad(value) {
        return (value < 10 ? '0' : '') + value;
      }

      function tick() {
        var remaining = target - Date.now();

        if (remaining <= 0) {
          target = readTarget();
          remaining = target - Date.now();
        }

        var totalSeconds = Math.max(0, Math.floor(remaining / 1000));
        var days = Math.floor(totalSeconds / 86400);
        var hrs = Math.floor((totalSeconds % 86400) / 3600);
        var mins = Math.floor((totalSeconds % 3600) / 60);
        var secs = totalSeconds % 60;

        if (units.days) units.days.textContent = pad(days);
        if (units.hours) units.hours.textContent = pad(hrs);
        if (units.minutes) units.minutes.textContent = pad(mins);
        if (units.seconds) units.seconds.textContent = pad(secs);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* --------------------------------------------------------------------------
     Batch notice dedupe: when the batch notice block renders (it carries the
     metafield text in data-kopstorm-batch-text), the same line still living in
     the product description is hidden so the message never shows twice. The
     product info re-renders server side on variant change, so a childList
     observer on the section re-runs the check after every swap.
  -------------------------------------------------------------------------- */

  function normalizeBatchText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function dedupeBatchNotice() {
    document.querySelectorAll('[data-kopstorm-batch-text]').forEach(function (notice) {
      var target = normalizeBatchText(notice.getAttribute('data-kopstorm-batch-text'));
      if (target.length < 8) return;

      var section = notice.closest('.shopify-section') || document;
      var candidates = section.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6, span, strong, div');

      candidates.forEach(function (el) {
        if (el.closest('[data-kopstorm-batch-text]')) return;
        if (el.closest('[data-kopstorm-batch-hidden]')) return;
        if (el.querySelector('p, div, li, ul, ol, h1, h2, h3, h4, h5, h6')) return;

        var text = normalizeBatchText(el.textContent);
        if (!text) return;

        var matches =
          text === target ||
          (text.indexOf(target) !== -1 && text.length <= target.length + 24) ||
          (target.indexOf(text) !== -1 && text.length >= target.length * 0.6);

        if (matches) {
          var blockEl = el.closest('p, li, h1, h2, h3, h4, h5, h6') || el;
          blockEl.setAttribute('data-kopstorm-batch-hidden', '');
          blockEl.style.display = 'none';
        }
      });
    });
  }

  var kopstormBatchObserved = typeof WeakSet === 'function' ? new WeakSet() : null;

  function observeBatchSections() {
    document.querySelectorAll('[data-kopstorm-batch-text]').forEach(function (notice) {
      var section = notice.closest('.shopify-section');
      if (!section || !kopstormBatchObserved || kopstormBatchObserved.has(section)) return;
      kopstormBatchObserved.add(section);

      var scheduled = false;

      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          dedupeBatchNotice();
          initBundleSelects();
        });
      }).observe(section, { childList: true, subtree: true });
    });
  }

  /* --------------------------------------------------------------------------
     Bundle variant selects (CRO variant): the native selects keep powering the
     bundle cart logic, but the visible control becomes a branded dropdown
     (trigger button + option list) so the OS default menu never shows. Every
     interaction writes back to the hidden native select and fires a change
     event, so the existing price/total scripts stay untouched.
  -------------------------------------------------------------------------- */

  function initBundleSelects() {
    document.querySelectorAll('.bundle-block select[data-variant-select]:not([data-kopstorm-select-ready])').forEach(function (select) {
      select.setAttribute('data-kopstorm-select-ready', '');

      var wrapper = document.createElement('div');
      wrapper.className = 'kopstorm-bundle-select';
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'kopstorm-bundle-select__trigger kopstorm-cro-only';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      var label = document.createElement('span');
      label.className = 'kopstorm-bundle-select__label';

      var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      chevron.setAttribute('viewBox', '0 0 10 7');
      chevron.setAttribute('class', 'kopstorm-bundle-select__chevron');
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML = '<path d="M1 1.25L5 5.25L9 1.25" stroke="currentColor" stroke-width="1.25" fill="none" stroke-linecap="round" stroke-linejoin="round"/>';

      trigger.appendChild(label);
      trigger.appendChild(chevron);

      var menu = document.createElement('div');
      menu.className = 'kopstorm-bundle-select__menu kopstorm-cro-only';
      menu.setAttribute('role', 'listbox');

      function syncLabel() {
        var current = select.options[select.selectedIndex];
        label.textContent = current ? current.textContent.trim() : '';

        menu.querySelectorAll('.kopstorm-bundle-select__option').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.getAttribute('data-value') === select.value);
        });
      }

      Array.prototype.forEach.call(select.options, function (option) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'kopstorm-bundle-select__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', option.value);
        item.textContent = option.textContent.trim();

        if (option.disabled) {
          item.disabled = true;
        } else {
          item.addEventListener('click', function () {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            close();
            syncLabel();
          });
        }

        menu.appendChild(item);
      });

      function close() {
        wrapper.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function (event) {
        event.stopPropagation();

        var willOpen = !wrapper.classList.contains('is-open');

        document.querySelectorAll('.kopstorm-bundle-select.is-open').forEach(function (other) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.kopstorm-bundle-select__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        wrapper.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      document.addEventListener('click', function (event) {
        if (!wrapper.contains(event.target)) close();
      });

      select.addEventListener('change', syncLabel);
      syncLabel();

      wrapper.appendChild(trigger);
      wrapper.appendChild(menu);
    });
  }

  /* --------------------------------------------------------------------------
     You May Also Like tabs (rectabs variant): the tab bar and the collection
     panels arrive with the recommendations fetch, so a delegated listener is
     used instead of direct bindings.
  -------------------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-kopstorm-rectab]');
    if (!tab) return;

    var bar = tab.closest('[data-kopstorm-rectabs]');
    var section = tab.closest('.shopify-section');
    if (!bar || !section) return;

    var key = tab.getAttribute('data-kopstorm-rectab');

    bar.querySelectorAll('[data-kopstorm-rectab]').forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll('[data-kopstorm-rectab-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-kopstorm-rectab-panel') !== key;
    });
  });

  /* --------------------------------------------------------------------------
     Boot + flag reactions
  -------------------------------------------------------------------------- */

  function init() {
    syncAnnouncementMessages();
    initEvergreenTimers();
    dedupeSizeChart();
    dedupeBatchNotice();
    observeBatchSections();
    initBundleSelects();

    /* App embeds inject after load; re-check briefly */
    var attempts = 0;
    var interval = setInterval(function () {
      dedupeSizeChart();
      attempts += 1;
      if (attempts >= 10) clearInterval(interval);
    }, 500);
  }

  document.addEventListener('kopstorm:flag', function () {
    syncAnnouncementMessages();
    dedupeSizeChart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
